import {Typography} from '@material-ui/core';
import React from 'react';

/**
 * material-table renders a string `title` as an <h6>. Pages put an <h1> above
 * the table, so that skips heading levels (WCAG 1.3.1). This renders the same
 * h6 styling as an <h2>; pass it as the table's `title` prop.
 */
export default function TableTitle({children}) {
  return (
    <Typography
      variant="h6"
      component="h2"
      style={{
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      }}
    >
      {children}
    </Typography>
  );
}
